import iwrmToolboxImage from "@/assets/toolbox/Outras imagens/IWRM Toolbox.png";

export default {
  name: 'HomePage',
  data() {
    return {
      iwrmToolboxImage
    };
  },
  computed: {
    paeLink() {
      const lang = this.$i18n.locale;
      switch (lang) {
        case 'en':
        case 'nl':
          return 'https://aguasamazonicas.otca.org/strategic-action-program/?lang=en';
        case 'es':
          return 'https://aguasamazonicas.otca.org/programa-de-acciones-estrategicas/';
        case 'pt':
        default:
          return 'https://aguasamazonicas.otca.org/programa-de-acoes-estrategicas/?lang=pt-br';
      }
    },
    iwrmTutorialVideoId() {
      const lang = this.$i18n.locale;
      switch (lang) {
        case 'es':
          return 'q7Gwp4qETUk';
        case 'en':
        case 'nl':
          return 'HfLd6r7pW6c';
        case 'pt':
        default:
          return 'dOZBjhhW_jA';
      }
    }
  }
}